 import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/globals';
import { Location } from '@angular/common';
import { RatersService } from 'app/services/rater/RatersService';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';
import { CryptoJs } from '../app/shared/crypto-js/crypto-js.component';
import { isUndefined } from 'util';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.scss']
})
export class AssessmentComponent implements OnInit, OnDestroy {

    assignmentId: string;
    raterAssignmentId: number;
    location: Location;
    displayPage = false;
    userType: string;
    encryptedData: any = {};
    code = '';
    clientId: number;

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _Globals: Globals,
        private _router: Router,
        private _RatersService: RatersService,
        private _AssessmentsService: AssessmentsService,
        private _CryptoJs: CryptoJs,
        private _toastr: ToastrService,
    ) {
        this._activatedRoute.queryParams.subscribe(params => {
            console.log('params', params);

            this.userType = params['uj'];
            this.encryptedData = JSON.parse(this._CryptoJs.decrypt(decodeURI(params['rw']), '9s6v9y$B&E!H@McQfTjWnZq4t7w!z%C*'));
            this.code = params['ly'];

            console.log(this.userType);
            console.log(this.encryptedData);
            console.log(this.code);

            if (this.encryptedData.xa < 50) {
                this.assignmentId = this.encryptedData.d1 + this.encryptedData.rd;
            } else if (this.encryptedData.xa >= 50) {
                this.assignmentId = this.encryptedData.rd + this.encryptedData.d1;
            }
            console.log('assignmentId', this.assignmentId);


            switch (this.userType) {
                case '1':
                    // client taking an assessment from link
                    this.assignmentDetailsForActivation(parseInt(this.assignmentId, 10), encodeURIComponent(this.code));
                    break;
                case '2':
                    // rater taking an assessment from link
                    this.clientRaterAssignmentDetailsForActivation(parseInt(this.assignmentId, 10), encodeURIComponent(this.code));
                    break;
            }
        });
    }

    ngOnInit() {}

    ngOnDestroy() {
        this._Globals.toggleMenuWithOutLoggin = false;
        console.log('ngOnDestroy');
    }

    // client
    assignmentDetailsForActivation(assignmentId: number, activationCode: string): void {
        this._AssessmentsService.getAssignmentDetailsForActivation(assignmentId, activationCode).subscribe((data: any) => {
            console.log('getAssignmentDetailsForActivation', data);

            switch (data.result.Result) {
                case -3:
                    this._Globals.assesmentErrorMessage = 'We are sorry. The assessment you are trying to reach has expired.';
                    this._router.navigate(['ASSESSMENTERRORPAGE']);
                    break;

                case -2:
                    this._Globals.assesmentErrorMessage = 'We are sorry. The assessment you are trying to reach does not exist anymore in our system. It was probably unassigned by your coach.';
                    this._router.navigate(['ASSESSMENTERRORPAGE']);
                    break;

                case -1:
                    this._Globals.assesmentErrorMessage = 'We are sorry. We cannot find the assessment you trying to reach.';
                    this._router.navigate(['ASSESSMENTERRORPAGE']);
                    break;

                case 0:
                    this._Globals.assesmentErrorMessage = 'We are sorry. An unexpected error happened while trying to access the request assessment.';
                    this._router.navigate(['ASSESSMENTERRORPAGE']);
                    break;

                case 1:
                    const _data = JSON.parse(this._CryptoJs.decrypt(JSON.parse(data.result.Data), 'Ps6v7y$B&E!H@McKfTjWnZq4t7w!z%8*'));
                    console.log('getAssignmentDetailsForActivation', _data);

                    let _assignmentId: any;
                    if (isUndefined(_data.AssignmentId)) {
                        _assignmentId = parseInt(this.assignmentId, 10);
                    } else {
                        _assignmentId = _data.AssignmentId;
                    }

                    this._Globals.invitationLinkUserId = _data.ClientId;
                    this._Globals.invitationLinkUserEmail = _data.ClientEmail;
                    this._Globals.invitationLinkUserName = _data.ClientFirstName;
                    this._Globals.invitationLinkUserLastName = _data.ClientLastName;
                    this._Globals.invitationLinkAssessmentId = _data.AssessmentId;
                    this._Globals.invitationLinkAssignmentId = _assignmentId;
                    this._Globals.invitationLinkAssessmentName = _data.AssessmentName;
                    this._Globals.invitationLinkLanguage = _data.Language;
                    this._Globals.invitationLinkFrom = 'pending';
                    this._Globals.invitacionLinkCompareIds = true;

                    switch (_data.UserStatus) {
                        case 1:
                            if (Number(_data.AssignmentStatus) === 3) {
                                this._toastr.warning('The assessment you tried to reach has already been completed.', 'ELI', {
                                    disableTimeOut: true
                                });
                                if (this._Globals.getUserId() === Number(_data.ClientId)) {
                                    this._router.navigate(['/app/client_assessments']);
                                    return
                                } else {
                                    // assessment completed
                                    this._Globals.assessmentCompleted = true;
                                    this._Globals.userEmail = _data.ClientEmail;
                                    console.log('Assessment completed');
                                    this._Globals.clearAllAndRediretToLogin();
                                    return;
                                }
                            } else {
                                if (this._Globals.getUserId() === Number(_data.ClientId)) {
                                    // user is logged in
                                    this._router.navigate(
                                        ['/app/assigned_assessment',
                                        'pending',
                                        _data.AssessmentId,
                                        _assignmentId,
                                        _data.AssessmentName,
                                        _data.Language],
                                        {state: { showBanner: false } });
                                } else {
                                    // redirect to login user logged out
                                    this.redirectToLogin(_assignmentId);
                                    return false;
                                }
                            }
                            break

                        case 2: // redirect to account activation
                            const temporalToken = this._CryptoJs.decrypt(_data.in8, '7s6v7y$B&E!H@McQfTjWnZq4t7w!z%C*');
                            console.log('temporalToken', temporalToken);

                            this._Globals.setFullName(this._CryptoJs.encrypt(_data.ClientFirstName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'), this._CryptoJs.encrypt(_data.ClientLastName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                            this._Globals.setUserId(this._CryptoJs.encrypt(_data.ClientId.toString(), '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                            this._Globals.setUserEmail(this._CryptoJs.encrypt(_data.ClientEmail, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                            this._Globals.setToken(temporalToken);
                            this._router.navigate(['/app/account_activation']);
                            break;
                    }

                    this._Globals.invitacionLinkCompareIds = false;
                    break;

                default:
                    this._Globals.assesmentErrorMessage = 'We are sorry. An unexpected error happened while trying to access the request assessment.';
                    this._router.navigate(['ASSESSMENTERRORPAGE']);
            }


        });
    }

    // rater
    clientRaterAssignmentDetailsForActivation(assignmentId: number, activationCode: string): void {
        this._RatersService.getClientRaterAssignmentDetailsForActivation(assignmentId, activationCode).subscribe((data: any) => {
            console.log('_GetClientRaterAssignmentDetails_response', data);

            switch (data.result.Result) {
                case -2:
                    this._Globals.assesmentErrorMessage = 'We are sorry. We could not find the requested assessment';
                    this._router.navigate(['ASSESSMENTERRORPAGE']);
                    break;

                case -1:
                    this._Globals.assesmentErrorMessage = 'We are sorry, activation code for the assessment is invalid';
                    this._router.navigate(['ASSESSMENTERRORPAGE']);
                    break;

                case 0:
                    this._Globals.assesmentErrorMessage = 'We are sorry, an error happened when trying to access the assessment';
                    this._router.navigate(['ASSESSMENTERRORPAGE']);
                    break;

                case 1:
                    const _data = JSON.parse(data.result.Data);
                    console.log(_data);

                    if (Number(_data.AssessmentId) === 0) {
                        this._Globals.assesmentErrorMessage = 'The specified assessment you are trying to reach is not longer available in our servers.';
                        this._router.navigate(['ASSESSMENTERRORPAGE']);
                        return;
                    }

                    let _assignmentId: any;
                    if (isUndefined(_data.AssignmentId)) {
                        _assignmentId = parseInt(this.assignmentId, 10);
                    } else {
                        _assignmentId = _data.AssignmentId;
                    }

                    this._Globals.invitationLinkUserId = _data.RaterId;
                    this._Globals.invitationLinkUserEmail = _data.RaterEmail;
                    this._Globals.invitationLinkUserName = _data.RaterFirstName;
                    this._Globals.invitationLinkUserLastName = _data.RaterLastName;
                    this._Globals.invitationLinkAssessmentId = _data.AssessmentId;
                    this._Globals.invitationLinkAssignmentId = _assignmentId;
                    this._Globals.invitationLinkAssessmentName = _data.AssessmentName;
                    this._Globals.invitationLinkLanguage = _data.Language;
                    this._Globals.invitationLinkFrom = 'rater';
                    this._Globals.invitacionLinkCompareIds = true;

                    const fullName = `${_data.ClientInfo.FirstName} ${_data.ClientInfo.LastName}`;
                    this._Globals.invitationLinkFullName = fullName;

                    if (parseInt(_data.AssignmentId, 10) === 0) {
                        this.displayPage = true;
                        this._Globals.toggleMenuWithOutLoggin = true;
                        console.log('Your assessment period has ended.');
                        return;
                    }

                    switch (_data.UserStatus) {
                        case 1:
                            if (Number(_data.AssignmentStatus) === 3) {
                                this._toastr.warning('The assessment you tried to reach has already been completed.', 'ELI', {
                                    disableTimeOut: true
                                });
                                if (this._Globals.getUserId() === Number(_data.RaterId)) {
                                    this._router.navigate(['/app/client_assessments']);
                                } else {
                                    // assessment completed
                                    this._Globals.assessmentCompleted = true;
                                    this._Globals.userEmail = _data.RaterEmail;
                                    console.log('Assessment completed');
                                    this._Globals.clearAllAndRediretToLogin();
                                    return;
                                }
                            } else {
                                if (this._Globals.getUserId() === Number(_data.RaterId)) {
                                    // user is logged in
                                    this._router.navigate(
                                        ['/app/assigned_assessment',
                                         'rater', _data.AssessmentId,
                                          _assignmentId,
                                          _data.AssessmentName,
                                          _data.Language,
                                          fullName],
                                         {state: {showBanner: false}});
                                } else {
                                    // user is logged out
                                    this.redirectToLogin(_assignmentId);
                                    return false;
                                }
                            }

                            break

                        case 2:
                            const temporalToken = this._CryptoJs.decrypt(_data.jh6, '7s6v7y$B&E!H@McQfTjWnZq4t7w!z%C*');
                            console.log('temporalToken', temporalToken);

                            this._Globals.setFullName(this._CryptoJs.encrypt(_data.RaterFirstName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'), this._CryptoJs.encrypt(_data.RaterLastName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                            this._Globals.setUserId(this._CryptoJs.encrypt(_data.RaterId.toString(), '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                            this._Globals.setUserEmail(this._CryptoJs.encrypt(_data.RaterEmail, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                            this._Globals.setToken(temporalToken);
                            this._router.navigate(['/app/account_activation']);
                            break;
                    }

                    this._Globals.invitacionLinkCompareIds = false;
                    break;
            }
        });
    }

    redirectToLogin(assignmentId: number) {
        this._Globals.deleteAllStorage();
        this._Globals.invitationLinkAssignmentId = assignmentId;
        this._Globals.isClientTakeAssessment = true;
        this._router.navigate(['/login']);
    }

    sidebarToggle() {
        if (this._Globals.sidebarVisible === false) {

            console.log('close user menu');
            $('.responsive-menu-wrap').removeClass('toogleMenu');
            $('.main-panel').css('margin-left', 225);
            $('.leftMenu-backdrop').css('right', 0);
            this.sidebarOpen();
        } else {
            this.sidebarClose();
            $('.main-panel').css('margin-left', 0);
            $('.leftMenu-backdrop').css('right', '-100%');
        }

    };

    sidebarOpen() {
        const body = document.getElementsByTagName('body')[0];
        // action open
        body.classList.add('nav-open');

        this._Globals.sidebarVisible = true;
    };

    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this._Globals.toggleButton.classList.add('toggled');
        setTimeout(() => {
            // icon animation
            this._Globals.toggleButton.classList.remove('toggled');
        }, 100);
        this._Globals.sidebarVisible = false;
        body.classList.remove('nav-open');
    };

}
